//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.AlongSpineBuilder.js";
import "../no/SelectLine.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.MultiTransitionLawBuilder.js";
import "../GeometricUtilities/GeometricUtilities.NonInflectingLawBuilder.js";
import "../GeometricUtilities/GeometricUtilities.SShapedLawBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[1,"AlongSpineData",0,"GeometricUtilities.AlongSpineBuilder",0],[1,"BaseLine",0,"SelectLine",0],[1,"EndValue",0,"Expression",0],[0,"Function",1,0],[0,"IsSimpleCubicAlongSpine",1,0],[1,"LawCurve",0,"Section",0],[0,"LawCurveOption",1,0],[0,"LawType",1,0],[1,"MultiTransitionLaw",0,"GeometricUtilities.MultiTransitionLawBuilder",0],[1,"NonInflectingLaw",0,"GeometricUtilities.NonInflectingLawBuilder",0],[0,"Parameter",1,0],[0,"ReverseDirection",1,0],[1,"SShapedLaw",0,"GeometricUtilities.SShapedLawBuilder",0],[1,"StartValue",0,"Expression",0],[1,"Value",0,"Expression",0]],[[["spine"],"SetSpineIntoBuilder",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.LawBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.LawBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.LawBuilder.Type = Object.freeze({
    "Constant" : "Constant", "Linear" : "Linear", "Cubic" : "Cubic", "LinearAlongSpine" : "LinearAlongSpine", "CubicAlongSpine" : "CubicAlongSpine", "ByEquation" : "ByEquation", "ByLawCurve" : "ByLawCurve", "MultiTransition" : "MultiTransition", "NonInflecting" : "NonInflecting", "SShaped" : "SShaped"});

SPLM.GeometricUtilities.LawBuilder.RetainLawCurveOption = Object.freeze({
    "KeepOriginal" : "KeepOriginal", "Replace" : "Replace"});

export default SPLM;